import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleSelectServerUserGuest } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../app/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { ServerSettingsUnauthenticated } from '../../../settings/services/ServerSettingsUnauthenticated';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { serverUserResetLoginRateLimiting } from '../actions/ServerUserMenuActions';
import { IServerUserInfo } from '../models/IServerUserInfo';

export const ServerUserResetLoginRateLimitingAction: IEntityAction<IServerUserInfo, {}> = {
  name: EntityActionNames.ServerUserResetLoginRateLimiting,
  translateName: Messages.resetLoginRateLimiting_action,
  isVisible: (_targetItems: IServerUserInfo[], _state: AppState) => {
    return FeatureFlags.localAuthLoginRateLimitingEnabled && ServerSettingsUnauthenticated.isServerDomainFamilyLocal();
  },
  isClickable: (_availableActions: {}, targetItems: IServerUserInfo[], _state: AppState) => {
    return targetItems.length > 0 && !isSingleSelectServerUserGuest(targetItems);
  },
  createReduxAction: (targetItems: IServerUserInfo[]) => serverUserResetLoginRateLimiting(targetItems)
};
